
// 客户编码、客户名称、客户经理/开发人、客户系、客户等级、行业大类、细分行业、内外渠、
// 客户状态、开发单位、创建人、创建时间
export const tableConfig = {
    name: 'customerDuplicate',
    fided: [
        {
            label: '客户编码',
            prop: 'customerCode',
            disabled: true,
            labelWidth: '120px',
            type: 'custom'
        },
        {
            label: '客户名称',
            prop: 'customerName',
            labelWidth: '120px',
            type: 'custom'
        },
        {
            label: '客户经理/开发人',
            prop: 'customerOwnerName',
            labelWidth: '120px',
            type: 'custom'
        },
        {
            label: '客户系',
            prop: 'customerGroupCode',
            labelWidth: '120px',
            type: 'select',
            optionsKey: 'SYS_CUST_RELATION_TYPE'
        },
        {
            label: '客户等级',
            labelWidth: '120px',
            prop: 'customerLevelCode',
            type: 'select',
            optionsKey: 'SYS_WM_CUSTOMER_LEVEL'
        },
        // {
        //     label: '内外渠',
        //     prop: 'isGroupCustomer',
        //     type: 'select',
        //     visible: true,
        //     rule: [
        //         { required: true, message: '内外渠不能为空', trigger: ['change', 'blur'] }
        //     ],
        //     optionsKey: 'LMDM_CUSTOMER_CHANNEL'
        // },
        // {
        //     label: '',
        //     prop: 'xx'
        // },
        {
            label: '行业大类',
            labelWidth: '120px',
            prop: 'industryType',
            type: 'select',
            optionsKey: 'SYS_INDUSTRY_TYPE'
        },
        {
            label: '细分行业',
            prop: 'industryType',
            labelWidth: '120px',
            type: 'select',
            optionsKey: 'SYS_INDUSTRY_TYPE'
        },
        {
            label: '内外渠',
            labelWidth: '120px',
            type: 'select',
            optionsKey: 'LMDM_CUSTOMER_CHANNEL',
            prop: 'customerChannel'
        },
        {
            label: '客户状态',
            prop: 'customerStatus',
            labelWidth: '120px',
            type: 'select',
            optionNum: 'SYS_WM_CUSTOMER_STATUS'
        },
        {
            label: '开发单位',
            prop: 'developmentUnitName',
            labelWidth: '120px',
            type: 'custom'
        },
        {
            label: '创建人',
            prop: 'createUserName',
            labelWidth: '120px',
            type: 'custom'
        },
        {
            label: '创建时间',
            labelWidth: '120px',
            prop: 'createTime',
            type: 'custom'
        }

    ],
    height: 325,
    columns: [
        {
            label: '客户编码',
            prop: 'customerCode',
            width: 130
        },
        {
            label: '客户名称',
            prop: 'customerName',
            width: 130
        },
        {
            label: '客户经理/开发人',
            prop: 'customerOwnerName',
            width: 140
        },
        {
            label: '客户系',
            prop: 'customerGroupCode',
            type: 'select',
            optionsKey: 'SYS_CUST_RELATION_TYPE',
            width: 140
        },
        {
            label: '客户等级',
            prop: 'customerLevelCode',
            type: 'select',
            optionsKey: 'SYS_WM_CUSTOMER_LEVEL',
            width: 140
        },
        {
            label: '行业大类',
            prop: 'industryType',
            type: 'select',
            optionsKey: 'SYS_INDUSTRY_TYPE',
            width: 140
        },
        {
            label: '细分行业',
            prop: 'industryType',
            width: 120,
            type: 'select',
            optionsKey: 'SYS_INDUSTRY_TYPE'
        },
        {
            label: '内外渠',
            type: 'select',
            optionsKey: 'LMDM_CUSTOMER_CHANNEL',
            prop: 'customerChannel',
            width: 100
        },
        {
            label: '客户状态',
            prop: 'customerStatus',
            type: 'select',
            optionsKey: 'SYS_WM_CUSTOMER_STATUS',
            width: 100
        },
        {
            label: '创建人',
            prop: 'createUserName'
        },
        {
            label: '创建时间',
            prop: 'createTime',
            width: 160
        }
    ]

};
